import React from "react";
import LoadingSpinner from "../LoadingSpinner";
import { Link } from "react-router-dom";

class NorandMonoProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  orderNow = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    console.log(this.country);
    this.redirectToCheckout = true;

    try {
      // Use the new Cart API with GraphQL mutation instead of deprecated checkout API
      const query = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const variables = {
        input: {
          lines: [
            {
              quantity: 1,
              merchandiseId: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zNzg1NDEyMTg4NTg1MQ=="
            }
          ]
        }
      };

      const response = await fetch(`https://norandstore.myshopify.com/api/2024-04/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '4afd7898ce2dc3f58b7ff3407f8d1b7b'
        },
        body: JSON.stringify({ query, variables })
      });

      const data = await response.json();
      
      if (data.data && data.data.cartCreate && data.data.cartCreate.cart) {
        const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;
        if (checkoutUrl) {
          window.location.href = checkoutUrl;
        } else {
          console.error('No checkout URL returned');
          this.setState({ loading: false });
        }
      } else {
        console.error('Cart creation failed:', (data.data && data.data.cartCreate && data.data.cartCreate.userErrors) || data.errors);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error creating cart:', error);
      this.setState({ loading: false });
    }
  };
  render() {
    return (
      <>
        {this.state.loading && <LoadingSpinner />}
        <div className="creativityMonoContainer">
          <div className="backdrop-blur">
            <div className="anim-bg">
              <div className="anim-form-1"></div>
              <div className="anim-form-2"></div>
              <div className="anim-form-3"></div>
              <div className="anim-form-4"></div>
              <div className="anim-form-5"></div>
              <div className="anim-form-6"></div>
              <div className="anim-form-7"></div>
            </div>
          </div>
          <div className="mainCreativity">
            <p className="p1Creativity">{this.props.mainText}</p>
            <p className="headerCreativityNorand">
              {this.props.NORANDTxt}
              <span className="headerCreativityMono">{this.props.MONO} </span>
            </p>
            <img src={this.props.picCut} alt="" className="cutMonoImg" />

            {/* <button onClick={this.orderNow} className="btnOrderNow"> */}
            <Link to={"/join-waitlist"}>
              <button className="btnOrderNow">
                {/* {this.props.btnText}
                <UserContext.Consumer>
                  {(priceInEur) => (priceInEur ? "€" : "$")}
                </UserContext.Consumer> */}
                Out of stock. Join Waitlist
                <img
                  src={this.props.buttArrowPic}
                  alt=""
                  className="arrowButtonMonoProduct"
                />
              </button>
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default NorandMonoProductCard;
